export const renderMaxLengthText = (string, maxCharacters) => {
  let charactersToDelete = 0;

  if (`${string}`.length > maxCharacters) {
    charactersToDelete = `${string}`.length - (maxCharacters - 3);
    return `${string.slice(0, -charactersToDelete)}...`;
  }
  return string;
};
